import React from 'react';
import { Redirect, Route, Switch, RouteComponentProps } from 'react-router-dom';
import { AdminTabs } from '~/components/Admin/AdminTabs';
import { Banner } from './Banner';
import { Macl } from './Macl';
import { ReportYear } from './ReportYear';
import { Reports } from './Reports';
import { Users } from './Users';

interface AdminProps extends Omit<RouteComponentProps, 'match'> {
    match: { url: string };
}

// Type assertions for TypeScript 5.x compatibility with react-router-dom v5
const SwitchComponent = Switch as any;
const RouteComponent = Route as any;
const RedirectComponent = Redirect as any;

export function Admin({ location, match }: AdminProps) {
    return location.pathname === '/admin' ? (
        <RedirectComponent to={{ pathname: `${match.url}/users` }} />
    ) : (
        <div className="container">
            <AdminTabs />
            <SwitchComponent>
                <RouteComponent path={`${match.url}/macl`} component={Macl} exact />
                <RouteComponent path={`${match.url}/reports`} component={Reports} exact />
                <RouteComponent path={`${match.url}/reportyear`} component={ReportYear} exact />
                <RouteComponent path={`${match.url}/banner`} component={Banner} exact />
                <RouteComponent path={`${match.url}/users`} component={Users} exact />
            </SwitchComponent>
        </div>
    );
}
